var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "white",
    viewBox: "0.5 0 24 24",
    enableBackground: "new 0.5 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico__x2F__click"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_204__x28_Stroke_x29_",
    d: "M4.871,1l15.258,11.625l-4.659,1.346l3.219,5.27L12.437,23l-3.546-5.759l-4.02,3.106V1z  M7.308,5.921v9.463l2.237-1.729l3.702,6.013l2.082-1.252l-3.604-5.9l3.073-0.888L7.308,5.921z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.d3e7297c96c5f44a21fffb6ced0b67a4.svg";
export { ForwardRef as ReactComponent };